export const SET_ASSETS_TO_DELETE = 'SET_ASSETS_TO_DELETE';

export const DELETE_ASSETS_REQUEST = 'DELETE_ASSETS_REQUEST';
export const DELETE_ASSETS_SUCCESS = 'DELETE_ASSETS_SUCCESS';
export const DELETE_ASSETS_FAIL = 'DELETE_ASSETS_FAIL';